<div class="col-auto-main home-wrapper">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12 text-center">
        <div class="page-header" style="margin-top: 30px; margin-bottom: 50px;">
          <label>{{ dayGreetings }}</label>
          <span class="greetings-date">{{ currentDateString }}</span>
          <span class="greetings-date" style="margin-top: 20px"><label>Company:</label> {{ currentCompanyName }}</span>
        </div>
      </div>
    </div>
    <!--<div style="margin: auto; width: 200px; margin-top: 100px" *ngIf="showLoading">
      <mat-progress-spinner [diameter]="200" [strokeWidth]="10" mode="indeterminate"></mat-progress-spinner>
    </div>-->
    <div class="row" style="max-width: 730px; margin: auto;">
      <div class="col-sm-12 text-center">
        <ng-container *ngFor="let app of apps">
          <a class="app-icon" *ngIf="app.visible" [class.disabled]="app.badge === 'soon'" [routerLink]="[app.url]"
             (mouseover)="showPopup(app)" (mouseleave)="hidePopup(app)">

            <span class="home-icon" [class.disabled]="app.disabled" [class.deprecated]="app.badge === 'deprecated'">
              <span class="notification-badge badge badge-warning"
                    *ngIf="app.notificationBadge > 0">{{ app.notificationBadge }}</span>
              <i class="{{app.iconClass}}" [ngClass]="{'zoom-home-icon': app.iconClass === 'zoom-icon'}"
                 [style.color]="app.color">{{ app.iconClassCode }}</i>
              <span class="badge beta" *ngIf="app.badge === 'beta'">Beta</span>
            </span>
            <span class="icon-title">{{ app.title }}</span>

            <div class="tooltip bs-tooltip-bottom" role="tooltip" *ngIf="app.showPopup">
              <div class="arrow"></div>
              <div class="tooltip-inner">
                {{ app.description }}
              </div>
            </div>
          </a>
        </ng-container>
      </div>
    </div>
  </div>
</div>
